import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import { equipmentTypesList } from '../../constants/equipmentTypesList';
import style from './style.module.scss';

const TableHardwareSkeleton = () => {
  return [...Array(7)].map(() => {
    const rowKey = uuidv4();
    return (
      <tr key={rowKey} className={cx(style.hardwareTableBodyRow, style.skeletonRow)}>
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        {equipmentTypesList.map((type) => (
          <td key={`${rowKey}-${type}`}>
            <SkeletonBlock className={style.skeletonText} />
          </td>
        ))}
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      </tr>
    );
  });
};

export default TableHardwareSkeleton;
